import AOS from "aos";
import "aos/dist/aos.css";
import DataNotFound from "component/shared/DataNotFound/DataNotFound";
import Paginator from "component/shared/Paginator/Paginator";
import { API_BASE_URL } from "configs/AppConfig";
import { END_POINTS } from "constants/APIConstant";
import { DateFormater } from "functions/dateTimeFormat";
import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link } from "react-router-dom";
import useSWR from "swr";
import Ispinned from "./Components/Ispinned";
import Notpinned from "./Components/Notpinned";
import "./PicturesAndVideosTabs.scss";
import LabelLang from "component/LabelLang/label-lang";
import CustomizedDatePicker from "component/customizedDatePicker/customized-date-picker";
import { pinnedSort } from "functions/pinnedSort";

function PicturesAndVideosTabs() {
  const intl = useIntl();

  React.useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  const allImages = [
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/newsr1.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/news1.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/news3.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/newsr3.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/news1.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
    {
      link: "",
      img: process.env.PUBLIC_URL + "/image/mediaLandingNews.png",
      title: "مؤتمر إطلاق المرصد الإحصائي",
      date: "22 أكتوبر 2022",
    },
  ];

  const [categoriesTabToggle, setcategoriesTabToggle] = useState(0);
  const defaultState = {
    pageSize: 6,
    currentPage: 1,
    startDate: null,
    endDate: null,
    title: null,
    photoCategoryId: null,
  };

  const [filters, setFilters] = useState(defaultState);
  const [date, setDate] = useState({ startDate: "", endDate: "", title: "" });

  const tabCategory = (index, id) => {
    setcategoriesTabToggle(index);
    setFilters((prev) => {
      return { ...prev, currentPage: 1, photoCategoryId: id };
    });
  };

  const onDateFilterChange = (passedValue, name) => {
    const value = passedValue === "" ? null : passedValue;
    setDate((prevState) => ({
      ...prevState,
      [name]: value ?? "",
    }));
    setFilters((prevState) => ({
      ...prevState,
      [name]: value ?? "",
    }));
  };

  // const onFilterChange = (e) => {
  //   const { name, value } = e.target;
  //   setDate((prev) => {
  //     return { ...prev, [name]: value };
  //   });
  // };

  const onPageIndexChange = (e, value) => {
    setFilters((prevState) => ({
      ...prevState,
      currentPage: value,
    }));
  };

  const categoriesData = useSWR({
    url: END_POINTS.PHOTO_CATEGORIES,
  });

  const photoAlbum = useSWR({
    url: `${END_POINTS.PHOTO_ALBUM}`,
    params: filters,
  });

  const renderAlbumsCategory = () => {
    const albumsCategoryData =
      !categoriesData ||
      categoriesData.error ||
      categoriesData.isLoading ||
      categoriesData.data === undefined
        ? []
        : categoriesData.data.data;
    const rendering = albumsCategoryData.map(
      ({ id, title, photoCategoryTranslations }, index) => {
        return (
          <li
            className={categoriesTabToggle === index + 1 ? "active" : "item"}
            onClick={() => tabCategory(index + 1, id)}
            key={index}
          >
            <LabelLang
              id="title"
              defaultValue={title}
              translations={photoCategoryTranslations}
            />
          </li>
        );
      }
    );
    const defaultPagnation = (
      <li
        className={categoriesTabToggle === 0 ? "active" : "item"}
        onClick={() => tabCategory(0, null)}
        key="default"
      >
        <FormattedMessage id="all-images" />{" "}
      </li>
    );
    const renderingList = [defaultPagnation, ...rendering];
    const paginatedList = <div className="pics-list">{renderingList}</div>;
    return paginatedList;
  };

  const renderPhotoAlbums = () => {
    const albums =
      photoAlbum.error ||
      photoAlbum.isLoading ||
      photoAlbum.data === undefined ||
      photoAlbum.data === null
        ? []
        : photoAlbum.data.data;

    const rendering =
      Object.keys(albums).length > 0 ? (
        <Paginator
          size={filters.pageSize}
          page={filters.currentPage}
          totalCount={photoAlbum?.data?.page?.totalCount}
          change={onPageIndexChange}
        >
          {albums
            .sort(pinnedSort)
            .map(
              (
                {
                  id,
                  thumbnail,
                  title,
                  publishingDate,
                  photoAlbumTranslations,
                },
                i
              ) => (
                <div key={i} className="col-12 col-md-6 col-lg-4">
                  <div className="text-center">
                    <Link to={`/mediaLanding/media/${id}`} className="ved-item">
                      <img
                        loading="lazy"
                        className="img1"
                        src={
                          thumbnail
                            ? `${API_BASE_URL}/${thumbnail}`
                            : allImages[0].img
                        }
                        alt="ved-item"
                      />
                      <h6>
                        <LabelLang
                          id="title"
                          defaultValue={title}
                          translations={photoAlbumTranslations}
                        />
                      </h6>
                      <span>
                        <DateFormater value={publishingDate} />
                      </span>
                    </Link>
                  </div>
                </div>
              )
            )}
        </Paginator>
      ) : (
        <DataNotFound />
      );
    return rendering;
  };

  const videosList = useSWR({
    url: END_POINTS.VIDEO_LIBRARY,
  });

  const radioList = useSWR({
    url: END_POINTS.RADIO_LIBRARY,
  });

  const renderVideoLibrary = () => {
    const videoss =
      videosList.error ||
      videosList.isLoading ||
      videosList.data === undefined ||
      videosList.data === null
        ? []
        : videosList.data.data;

    const rendering =
      Object.keys(videoss).length > 0 ? (
        <Paginator size={5}>
          {videoss.map(
            (
              {
                url,
                title,
                publishingDate,
                isPinned,
                videoLibraryTranslations,
              },
              i
            ) =>
              isPinned === true ? (
                <Ispinned
                  key={i}
                  url={url}
                  title={title}
                  publishingDate={publishingDate}
                  videoLibraryTranslations={videoLibraryTranslations}
                />
              ) : (
                <Notpinned
                  key={i}
                  url={url}
                  title={title}
                  publishingDate={publishingDate}
                  videoLibraryTranslations={videoLibraryTranslations}
                />
              )
          )}
        </Paginator>
      ) : (
        <DataNotFound />
      );

    return rendering;
  };

  const renderRadioLibrary = () => {
    const radioss =
      radioList.error ||
      radioList.isLoading ||
      radioList.data === undefined ||
      radioList.data === null
        ? []
        : radioList.data.data;

    const rendering =
      Object.keys(radioss).length > 0 ? (
        <Paginator size={5}>
          {radioss.map(
            (
              {
                url,
                title,
                publishingDate,
                isPinned,
                videoLibraryTranslations,
              },
              i
            ) =>
              isPinned === true ? (
                <Ispinned
                  key={i}
                  url={url}
                  title={title}
                  publishingDate={publishingDate}
                  videoLibraryTranslations={videoLibraryTranslations}
                />
              ) : (
                <Notpinned
                  key={i}
                  url={url}
                  title={title}
                  publishingDate={publishingDate}
                  videoLibraryTranslations={videoLibraryTranslations}
                />
              )
          )}
        </Paginator>
      ) : (
        <DataNotFound />
      );

    return rendering;
  };

  return (
    <>
      <div id="albums" className="row mt-5">
        <div className="col-12">
          <div className="m__title">
            <h3>{intl.formatMessage({ id: "image-albums" })}</h3>
          </div>
        </div>
        <div className="col-12 col-lg-4">
          <div
            className="searchBy-ob"
            data-aos="fade-left"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
          >
            <h5>{intl.formatMessage({ id: "browse-images-by-type" })}:</h5>
            <ul>{renderAlbumsCategory()}</ul>
          </div>
        </div>
        <div className="col-12 col-lg-8">
          <div
            className="news-tabs"
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
          >
            <div className={"active-item-news-tabs"}>
              <div className="body-news">
                <div className="row mb-3">
                  <div className="col-12 col-md-6">
                    <div className="form-label">
                      <label className="ps-2">
                        {intl.formatMessage({ id: "images-from" })}
                      </label>
                      <div className="form-label-container">
                        <CustomizedDatePicker
                          dateFormat="dd/MM/yyyy"
                          value={date.startDate}
                          onChange={(e) =>
                            onDateFilterChange(e.target.value, "startDate")
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6">
                    <div className="form-label">
                      <label className="ps-2">
                        {intl.formatMessage({ id: "to" })}
                      </label>
                      <div className="form-label-container">
                        <CustomizedDatePicker
                          dateFormat="dd/MM/yyyy"
                          value={date.endDate}
                          onChange={(e) =>
                            onDateFilterChange(e.target.value, "endDate")
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row gy-3 gy-lg-0 gx-0 gx-md-4">
                  {Object.keys(renderPhotoAlbums()).length > 0 ? (
                    renderPhotoAlbums()
                  ) : (
                    <DataNotFound />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="videos" className="row gx-lg-5 mt-5">
        <div className="col-12 col-lg-6">
          <div className="m__title">
            <h3>{intl.formatMessage({ id: "video-library" })}</h3>
          </div>
          <div className="col-12">
            <div
              className="row gy-4 gx-0 gx-md-4"
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-easing="ease-in-sine"
            >
              {Object.keys(renderVideoLibrary()).length > 0 ? (
                renderVideoLibrary()
              ) : (
                <DataNotFound />
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="m__title">
            <h3>{intl.formatMessage({ id: "radio-library" })}</h3>
          </div>
          <div className="col-12">
            <div
              className="row gy-4 gx-0 gx-md-4"
              data-aos="fade-right"
              data-aos-duration="1000"
              data-aos-easing="ease-in-sine"
            >
              {Object.keys(renderRadioLibrary()).length > 0 ? (
                renderRadioLibrary()
              ) : (
                <DataNotFound />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PicturesAndVideosTabs;
